define.alias("shared/components/shared/media-items/media-item-video", "calendar/components/shared/media-items/media-item-video");